import type { IconProps } from "../types";

export const Phone = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M13.832 16.568 15.4 15.8 17 15 22 15 22 22A18 18 0 0 1 2 4L2 2 9 2 9 7 7.732 8.951A14 14 0 0 0 13.832 16.568Z" />
  </svg>
);
